module.exports = __webpack_public_path__ + "static/media/lg66.fa9adce2.png";